import { jsx as r } from "@emotion/react/jsx-runtime";
import { useMemo as I } from "react";
import { StyledMenuList as T } from "./MenuList.styled.js";
import { SuggestionLabel as j } from "../../../../MenuList/MenuSections/SuggestionLabel.js";
import { getSections as v, shouldDisplayMenu as D } from "../../../helpers.js";
import { useMenuList as F } from "../../hooks/useMenuList.js";
import { useMultiSelectContext as H } from "../../MultiSelectContext.js";
const K = () => {
  const {
    sections: t,
    emptyMessage: s,
    maxHeight: c,
    loadMore: l,
    isLoading: a,
    hasMore: u,
    selectedValue: m,
    onChange: p,
    selectableCardChildren: d,
    creatableProps: g,
    showMenu: M,
    searchValue: e,
    notice: f,
    isSuggestionVisible: o,
    variant: h,
    customSectionLabel: S,
    position: b,
    maxSelected: C,
    ignoreSearchFilter: i,
    addCreatedSection: L,
    offsetTextInput: x
  } = H(), {
    onItemClick: y,
    isSelected: V
  } = F({
    selectedValue: m,
    onChange: p,
    searchValue: e,
    maxSelected: C
  }), n = I(() => v({
    sections: [...t],
    searchValue: e,
    ignoreSearchFilter: i
  }), [t, e, i]), {
    suggestionProps: k,
    isMenuListVisible: P
  } = g || {
    isMenuListVisible: !0
  };
  return D(n, M, s, o) ? /* @__PURE__ */ r(T, { offset: x, hasNotice: !!f, position: b, maxHeight: c, sections: P ? n : [], itemType: "checkbox", onChange: y, isChecked: (w) => !!V(w), loadMore: l, isLoading: a, hasMore: u, emptyMessage: s, selectableCardChildren: d, isSuggestionVisible: o, suggestionProps: {
    onClick: L,
    label: /* @__PURE__ */ r(j, { suggestionProps: k, searchValue: e })
  }, variant: h, customSectionLabel: S }) : null;
};
export {
  K as SelectMenuList
};
